import { useRouter, } from 'next/router';
import isQueryValueTrue from '../../utils/isQueryValueTrue';

export default function useIsLabel() {
  const router = useRouter();

  return isQueryValueTrue(router.query.isLabel);
}
